import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const ScrollToTop = function () {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [pathname]);
};

export default ScrollToTop;
